var React = require('react');

function ChevronLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.7 41.5L4 .8S2.2-1 .8.8.4 4 .4 4l39.9 39.8L.5 83s-1.4 1.8.5 3.2c1.4 1.4 3.2.5 3.2.5L44.9 46s1-1 1-2.2c-.2-1.5-1.2-2.3-1.2-2.3z"}));
}

ChevronLight.defaultProps = {"viewBox":"0 0 45.9 87"};

module.exports = ChevronLight;

ChevronLight.default = ChevronLight;
